import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "post-notes" }
const _hoisted_2 = { class: "q-px-md q-mb-md shadow-1 radius" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  key: 0,
  class: "on-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_items_loader = _resolveComponent("async-items-loader")!
  const _component_add_post_note = _resolveComponent("add-post-note")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_humanize_time = _resolveComponent("humanize-time")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_async_items_loader, {
      task: _ctx.task,
      "num-items": _ctx.notes.length,
      class: "q-mb-md"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" This post has no notes. ")
      ]),
      _: 1
    }, 8, ["task", "num-items"]),
    _createVNode(_component_add_post_note, {
      "post-id": _ctx.postId,
      class: "q-mb-md",
      outlined: "",
      onAdded: _ctx.add
    }, null, 8, ["post-id", "onAdded"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note) => {
        return (_openBlock(), _createElementBlock("div", {
          key: note.id,
          class: "post-notes__note q-py-md"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_icon, { name: "fa fa-user-circle" }),
            (note.user)
              ? (_openBlock(), _createElementBlock("strong", _hoisted_4, _toDisplayString(note.user.firstName) + " " + _toDisplayString(note.user.lastName), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_q_space),
            _createVNode(_component_humanize_time, {
              time: note.addedAt,
              class: "text-grey-8"
            }, null, 8, ["time"])
          ]),
          _createElementVNode("p", null, _toDisplayString(note.content), 1)
        ]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.notes.length]
    ])
  ]))
}